




















































import 'vue-material-design-icons/styles.css'
import Ribbon from 'vue-ribbon'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import Flipbook from './Flipbook'

export default
  name: 'app'
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon, Ribbon }
  data: ->
    pages: [],
    pagesHiRes: [],
    hasMouse: true
    pageNum: null
  methods:
    onFlipLeftStart: (page) -> console.log 'flip-left-start', page
    onFlipLeftEnd: (page) ->
      console.log 'flip-left-end', page
      window.location.hash = '#' + page
    onFlipRightStart: (page) -> console.log 'flip-right-start', page
    onFlipRightEnd: (page) ->
      console.log 'flip-right-end', page
      window.location.hash = '#' + page
    onZoomStart: (zoom) -> console.log 'zoom-start', zoom
    onZoomEnd: (zoom) -> console.log 'zoom-end', zoom
    setPageFromHash: ->
      n = parseInt window.location.hash.slice(1), 10
      @pageNum = n if isFinite n
  mounted: ->
    window.addEventListener 'keydown', (ev) =>
      flipbook = @$refs.flipbook
      return unless flipbook
      flipbook.flipLeft() if ev.keyCode == 37 and flipbook.canFlipLeft
      flipbook.flipRight() if ev.keyCode == 39 and flipbook.canFlipRight

    # Simulate asynchronous pages initialization
    setTimeout (=>
      @pages = [
        null
        'images/001.jpg'
        'images/002.jpg'
        'images/003.jpg'
        'images/004.jpg'
        'images/005.jpg'
        'images/006.jpg'
        'images/007.jpg'
        'images/008.jpg'
        'images/009.jpg'
        'images/010.jpg'
        'images/011.jpg'
        'images/012.jpg'
        'images/013.jpg'
        'images/014.jpg'
        'images/015.jpg'
        'images/016.jpg'
        'images/017.jpg'
        'images/018.jpg'
        'images/019.jpg'
        'images/020.jpg'
        'images/021.jpg'
        'images/022.jpg'
        'images/023.jpg'
        'images/024.jpg'
        'images/025.jpg'
        'images/026.jpg'
        'images/027.jpg'
        'images/028.jpg'
        'images/029.jpg'
        'images/030.jpg'
        'images/031.jpg'
        'images/032.jpg'
        'images/033.jpg'
        'images/034.jpg'
        'images/035.jpg'
        'images/036.jpg'
        'images/037.jpg'
        'images/038.jpg'
        'images/039.jpg'
        'images/040.jpg'
        'images/041.jpg'
        'images/042.jpg'
        'images/043.jpg'
        'images/044.jpg'
        'images/045.jpg'
        'images/046.jpg'
        'images/047.jpg'
        'images/048.jpg'
        'images/049.jpg'
        'images/050.jpg'
        

      ]
      @pagesHiRes = [
        null
        'images-large/001.jpg'
        'images-large/002.jpg'
        'images-large/003.jpg'
        'images-large/004.jpg'
        'images-large/005.jpg'
        'images-large/006.jpg'
        'images-large/007.jpg'
        'images-large/008.jpg'
        'images-large/009.jpg'
        'images-large/010.jpg'
        'images-large/011.jpg'
        'images-large/012.jpg'
        'images-large/013.jpg'
        'images-large/014.jpg'
        'images-large/015.jpg'
        'images-large/016.jpg'
        'images-large/017.jpg'
        'images-large/018.jpg'
        'images-large/019.jpg'
        'images-large/020.jpg'
        'images-large/021.jpg'
        'images-large/022.jpg'
        'images-large/023.jpg'
        'images-large/024.jpg'
        'images-large/025.jpg'
        'images-large/026.jpg'
        'images-large/027.jpg'
        'images-large/028.jpg'
        'images-large/029.jpg'
        'images-large/030.jpg'
        'images-large/031.jpg'
        'images-large/032.jpg'
        'images-large/033.jpg'
        'images-large/034.jpg'
        'images-large/035.jpg'
        'images-large/036.jpg'
        'images-large/037.jpg'
        'images-large/038.jpg'
        'images-large/039.jpg'
        'images-large/040.jpg'
        'images-large/041.jpg'
        'images-large/042.jpg'
        'images-large/043.jpg'
        'images-large/044.jpg'
        'images-large/045.jpg'
        'images-large/046.jpg'
        'images-large/047.jpg'
        'images-large/048.jpg'
        'images-large/049.jpg'
        'images-large/050.jpg'
      ]
    ), 1

    window.addEventListener 'hashchange', @setPageFromHash
    @setPageFromHash()
